module.exports = __webpack_public_path__ + "media/images/responsive/keywords/keyword_nihonteien-baab124d64c763b1281945c2f9236457.jpg";